/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type NpsByDeviceBarChart_answersReport = {|
  +npsByDevice: ?$ReadOnlyArray<?{|
    +device: ?string;
    +nps: ?number;
    +count: ?number;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NpsByDeviceBarChart_answersReport",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "NpsByDevice",
      "name": "npsByDevice",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "device",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "nps",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswersReport"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/NpsByDeviceBarChart/__generated__/NpsByDeviceBarChart_answersReport.graphql.js